export type AnalyticsConsent = 'granted' | 'denied'

/**
 * The visitor's analytics-cookie choice (Thai PDPA). `null` until they pick
 * one — the consent banner shows while it is null, and resetting it to null
 * reopens the banner. Stored per browser; shared by the banner, the footer
 * link and the analytics plugin.
 */
export const useAnalyticsConsent = createGlobalState(() =>
  useLocalStorage<AnalyticsConsent | null>('analytics_consent', null)
)
